export default __webpack_public_path__ + "static/media/CeraRoundProMedium.48064439.woff2";